import React from "react";
import Combobox from "../../shared/Combobox";
import APIS from "../../constant/Endpoint";
import MultiSelectField from "../../shared/MultiSelectField";
import { useForm } from "react-hook-form";
import { tw } from "@careinfo/tailwind";
import Button from "../../shared/Button";
interface Props {
  handleUpdate: (values: any, setError: any) => Promise<void>;
  isLoading: boolean;
  pageData: any;
}
const Modalform = ({ handleUpdate, isLoading, pageData }: Props) => {
  const { control, handleSubmit, setError } = useForm({
    defaultValues: async () => {
      return {
        popup_pages: pageData?.popup_pages?.map((item) => {
          return {
            value: item?.id,
            label: item?.title,
          };
        }),
      };
    },
  });
  return (
    <>
      <form onSubmit={handleSubmit((data) => handleUpdate(data, setError))}>
        <div className={tw`w-[400px]`}>
          <MultiSelectField
            label="Popup"
            queryKey="popup-modal"
            params={{}}
            name={"popup_pages"}
            control={control}
            url={APIS.POPUP}
          />
        </div>
        <div className={tw`w-24 ml-auto mt-4`}>
          <Button label="Add" />
        </div>
      </form>
    </>
  );
};

export default Modalform;
